<template>
  <div>
    <div class="privacy-wrap">
      <div class="title-wrap">{{ appTypeTitle }}隐私政策</div>
      <div class="top-space">
        <p class="gray">修改时间2024年01月08号</p>
        <p class="gray">生效时间2024年01月08号</p>
        <p class="gray">发布时间2024年01月08号</p>
      </div>
      <div class="text-offset-2">
        中保车服科技服务股份有限公司（以下称“中保车服”）非常重视对您的个人隐私保护，中保车服将按照本隐私政策（以下称“本政策”）收集、使用、共享和保护您的个人信息。在您使用中保车服的产品前，请您仔细阅读并全面了解本政策。对于本政策中与您的权益存在重大关系的条款，中保车服已将字体加粗以提示您注意。
      </div>
      <div class="text-offset-2 importance">
        当您浏览、访问中保车服平台、官方网站及/或使用中保车服的任一产品时，即表示您已经同意中保车服按照本政策来收集、使用、共享和保护您的个人信息。您使用或在中保车服更新本隐私政策后（中保车服会及时提示您更新的情况）继续使用中保车服的产品与/或服务，即意味着您同意本隐私政策(含更新版本)内容，并且同意中保车服按照本隐私政策收集、使用、保存和共享您的相关信息。
        <span
          class="normal"
        >中保车服收集、使用、共享和保护您的个人信息，是在遵守国家法律法规规定的前提下，出于向您提供中保车服的产品并不断提升产品质量的目的，包括但不限于支持中保车服开展中保车服产品相关的市场活动、完善现有产品功能、开发新产品。</span>如果您不同意相关协议或其中任何条款约定，您应立即停止使用中保车服。
      </div>
      <div class="first-wrap">一、信息的收集范围</div>
      <div class="text-offset-2">您授权中保车服收集您的以下个人信息：</div>
      <div class="text-offset-2">
        1.为帮助您成为中保车服的用户，您需要向中保车服提供您的⼿机号码，并设置您在中保车服平台的⽤户密码。
      </div>
      <div class="text-offset-2">
        2.<span class="importance">位置信息</span>：经您授权，中保车服会通过IP地址、<span class="importance">GPS</span>以及能够提供相关信息的其他传感器（附近设备、Wi-Fi接入点和基站信息）来校准您的位置信息，以便向您发送附近的订单、记录您的<span
          class="importance"
        >轨迹</span>、帮您规划导航路线。如果您拒绝中保车服平台获取位置信息，您将无法接单或者使⽤其他位置相关服务。
      </div>
      <div class="text-offset-2">
        3.<span class="importance">相机</span>
        ：经您授权，中保车服会收集您的相机信息，以便为您提供拍照、录视频功能，帮助您在现场作业时通过中保车服产品收集客户资料。您可以自行选择开启或关闭相机的授权，一旦关闭您将无法通过拍照、视频功能。
      </div>
      <div class="text-offset-2">
        4.<span class="importance">相册</span>：经您授权，中保车服会收集您的相册信息，以便您上传图片、上传视频功能。您可以自行选择开启或关闭相册的授权，一旦关闭您将无法上传图片、上传视频。
      </div>
      <div class="text-offset-2">
        5.<span class="importance">麦克风</span>：经您授权，中保车服会收集您的录音信息，监测作业员和客户现场作业过程中的环境声音情况，避免后续纠纷、提升安全能力，也可通过申请麦克风权限以实现视频连线时获得声音。您可以自行选择开启或关闭麦克风的授权。
      </div>
      <div class="text-offset-2">
        6.<span class="importance">视频服务</span>：为您提供视频连线中保车服后台人员服务，辅助您完成现场作业。中保车服会请求您授权相机、麦克风权限。您如果拒绝授权提供，将无法使用此功能，但不影响您正常使用中保车服产品。
      </div>
      <div class="text-offset-2">
        7.<span class="importance">支付信息</span>：您的支付时间、支付金额、支付工具、<span
          class="importance"
        >银行账户及支付账户信息；</span>
      </div>
      <div
        class="text-offset-2"
        v-if="isAii"
      >
        8.您想要添加团队成员时，中保车服会收集团队成员<span
          class="importance"
        >头像、年龄、性别、学历、政治面貌、职业、所在城市、角色和管理地区信息</span>，用于维护该团队成员电子工牌、作业范围、作业角色、运营服务信息。
      </div>
      <div class="text-offset-2">
        {{
          isAii ? "9" : "8"
        }}.您想要进行作业时，中保车服会收集您的或者第三方人员的<span
          class="importance"
        >姓名、身份证信息、驾驶证信息、行驶证信息、车辆信息（车牌号、品牌、型号、颜色）、银行卡</span>信息。
      </div>
      <div class="text-offset-2">
        {{ isAii ? "10" : "9" }}.<span class="importance">设备信息</span>
        (包括设备型号、Android
        ID、设备设置、MAC地址以及IMEI、IDFA、IDFV、OAID设备标识符、操作系统、系统语言、分辨率、电信运营商、SIM卡IMSI信息、SIM卡归属地、设备环境)使用软件及相关服务的频率、崩溃数据、总体安装、使用情况、性能数据信息。
      </div>
      <div class="text-offset-2">
        {{ isAii ? "11" : "10" }}.<span
          class="importance"
        >读取当前运行应用进程</span>：当⼀个设备有多个 APP 的推送链路同时活跃时，我们采⽤
        合并链路技术，随机合并成⼀条链路，以达到为⽤户省电省流量的⽬的；同时有助于帮助您洞察您终端⽤户的兴趣偏好，实现⽤户分群推送功能。
      </div>
      <div class="text-offset-2">
        {{ isAii ? "12" : "11" }}.<span class="importance">电话</span>：经您授权，我们会通过联系客户、访问拨号功能。您可以自行选择开启或关闭电话的授权，一旦关闭您将无法在工单中直接点击拨打联系客户。
      </div>

      <div class="text-offset-2">
        {{ isAii ? "13" : "12" }}.<span class="importance">通讯录</span>：经您授权，我们会通过通讯录联系客户。您可以自行选择开启或关闭通讯录的授权，一旦关闭您将无法在工单中通过通讯录拨打联系客户。
      </div>
      <div class="text-offset-2">
        {{ isAii ? "14" : "13" }}.<span class="importance">悬浮窗</span>：经您授权，在系统设置中打开悬浮窗权限，会生成一个悬浮图标方便快速联系客服。您可以自行选择开启或关闭悬浮窗的授权，一旦关闭您将无法在悬浮窗口中拨打联系客服。
      </div>
      <div class="text-offset-2">
        {{ isAii ? "15" : "14" }}.<span class="importance">通知权限</span>：获取目的：方便用户收到推送订单进行作业，获取通知权限范围：订单通知和订单作业通知、消息提醒。
      </div>
      <div class="text-offset-2">
        {{
          isAii ? "16" : "15"
        }}.其他根据中保车服具体产品及服务的需要而收集的您的个人信息，您对中保车服及中保车服的产品的意见、建议、您曾经使用或经常使用的移动应用软件以及使用场景和使用习惯信息。
      </div>

      <div class="first-wrap">二、信息的必要性</div>
      <div class="text-offset-2">
        1、手机号码信息：基本业务功能，必要的个人信息；
      </div>
      <div class="text-offset-2">
        2、位置信息：基本业务功能，必要的个人信息；
      </div>
      <div class="text-offset-2">3、相机：基本业务功能，非必要的个人信息；</div>
      <div class="text-offset-2">4、相册：基本业务功能，非必要的个人信息；</div>
      <div class="text-offset-2">
        5、麦克风：扩展业务功能，非必要的个人信息；
      </div>
      <div class="text-offset-2">
        6、视频服务：扩展业务功能，非必要的个人信息；
      </div>
      <div class="text-offset-2">
        7、支付信息：扩展业务功能，非必要的个人信息；
      </div>
      <div class="text-offset-2">
        8、您的或者第三方人员的<span
          class="importance"
        >姓名、身份证信息、驾驶证信息、行驶证信息、车辆信息（车牌号、品牌、型号、颜色）、银行卡</span>信息：基本业务功能，非必要的个人信息；
      </div>
      <div class="text-offset-2">
        9、设备信息：基本业务功能，非必要的个人信息；
      </div>
      <div class="text-offset-2">
        10、读取当前运行应用进程: 基本业务功能，非必要的个人信息。
      </div>

      <div class="first-wrap">三、信息的收集方法</div>
      <div class="text-offset-2">您授权中保车服收集您的以下个人信息：</div>
      <div class="text-offset-2">
        1.中保车服将收集和储存在您浏览、访问中保车服平台及/或使用中保车服的产品时主动向中保车服提供的信息；
      </div>
      <div class="text-offset-2">
        2.中保车服将收集和储存在您浏览、访问中保车服平台及/或使用中保车服的产品时所处的地理位置及目的地信息；
      </div>
      <div class="text-offset-2">
        3.中保车服将收集和储存中保车服在向您提供中保车服产品的过程中记录的与您有关的信息；
      </div>
      <div class="text-offset-2">
        4.中保车服将收集和储存您通过中保车服的客服人员及/或其他渠道主动提交或反馈的信息；
      </div>
      <div class="text-offset-2">
        5.中保车服将向关联公司、商业合作伙伴及第三方独立资料来源，收集和储存其合法获得的与您有关的信息；
      </div>
      <div class="text-offset-2">
        6.中保车服将向依法设立的征信机构查询您的相关<span
          class="importance"
        >信用信息，信用分、信用报告。</span>
      </div>

      <div class="first-wrap">四、信息的用途</div>
      <div class="text-offset-2">您授权中保车服收集您的以下个人信息：</div>
      <div class="text-offset-2">
        1.向您提供中保车服的产品，并进行中保车服相关网站及APP的管理和优化；
      </div>
      <div class="text-offset-2">
        2.开展中保车服产品及服务相关的市场活动，在您同意后向您推送最新的市场活动信息及优惠方案；
      </div>
      <div class="text-offset-2">3.设计、开发、推广全新的产品及服务；</div>
      <div class="text-offset-2">
        4.提高中保车服产品及服务安全性，身份验证、客户服务、安全防范、诈骗监测、存档和备份；
      </div>
      <div class="text-offset-2">
        5.协助行政机关、司法机构有权机关开展调查，并遵守适用法律法规及其他向有权机关承诺之义务；
      </div>
      <div class="text-offset-2">
        6.在收集信息之时所通知您的用途以及与上述任何用途有关的其他用途；
      </div>
      <div class="text-offset-2">
        7.此外，中保车服可能向您发送与上述用途有关的信息和通知，为保证服务完成所必须的验证码、使用产品或服务时所必要的推送通知、当前作业费用信息、关于中保车服产品或服务的新闻以及市场活动及优惠促销信息。
      </div>

      <div class="first-wrap">五、信息的共享</div>
      <div class="text-offset-2">
        中保车服对您的个人信息承担保密义务，您授权中保车服在下列情况下将您的信息与第三方共享，且受信息收集范围的约束：
      </div>
      <div class="text-offset-2">
        1.为了提升中保车服的产品及服务质量或向您提供全新的产品及服务，中保车服会在关联公司内部共享您的相关信息，也可能将中保车服收集的信息提供给第三方用于分析和统计；
      </div>
      <div class="text-offset-2">
        2.为保障中保车服产品相关功能的实现与应用的稳定运行，中保车服会接入第三方提供的软件开发包（SDK）以实现相关目的。关于第三方如何收集、使用您的个人信息，建议您参考第三方SDK的相关服务协议及个人信息处理规则。如果您希望进一步了解中保车服所接入的第三方SDK情况，请您阅读第三方SDK情况说明。
      </div>
      <div class="text-offset-2">
        3.如果您通过中保车服平台使用的某些产品及服务是由中保车服的合作伙伴提供的，或是由中保车服与合作伙伴或供应商共同提供的；中保车服将与其共享向您提供相应产品及服务所必需的信息；
        由于中保车服的合作方较多且在动态变化中，在此无法一一列举，如您需详细了解相关情况，请拨打中保车服的客服热线<span
          style="color: #3399ff"
          @click="callPhone('4000026862')"
        >4000026862</span>
      </div>

      <div class="text-offset-2">
        4.为了与第三方开展联合推广活动，中保车服可能与其共享开展活动所必需的以及在活动过程中产生的相关信息；
      </div>
      <div class="text-offset-2">
        5.为了维护您的合法权益，在协助处理与您有关的交易纠纷或争议时，中保车服会向您的交易相对方或存在利害关系的第三方提供解决交易纠纷或争议所必需的信息；
      </div>
      <div class="text-offset-2">
        6.根据法律法规的规定及商业惯例，中保车服需要接受第三方的审计或尽职调查时，可能向其提供您的相关信息；
      </div>
      <div class="text-offset-2">
        7.根据法律法规的规定或行政机关、司法机构有权机关要求，中保车服会向其提供您的相关信息；
      </div>
      <div class="text-offset-2">
        8.其他经您同意或授权可以向第三方提供您的个人信息的情况。
      </div>

      <div class="first-wrap">六、信息的安全及保护措施</div>
      <div class="text-offset-2">1.信息的存储时限</div>
      <div class="text-offset-2">
        中保车服收集和产生的个人信息将存储在中华人民共和国境内。中保车服仅在本政策所述目的所必需期间和法律法规及监管规定的时限内保存您的个人信息，如果超出本政策所描述的所需期间和法律法规及监管规定的时限，中保车服将清除您所有的个人信息。例如：您登陆时的手机号码、地理位置。
      </div>
      <div class="text-offset-2">2.信息安全</div>
      <div class="text-offset-2">
        中保车服及中保车服的关联公司将采用严格的安全制度以及行业通行的安全技术和程序来确保您的个人信息不被丢失、泄露、毁损或滥用。中保车服的员工及服务外包人员将受到保密协议的约束，同时还将受到数据信息的权限控制和操作监控。
      </div>
      <div class="text-offset-2">
        请您注意，任何安全系统都存在可能的及未知的风险。
      </div>
      <div class="text-offset-2">
        您的交易相对方、您访问的第三方网站经营者、您使用的第三方服务提供者和通过中保车服获取您的个人信息的第三方可能有自己的隐私权保护政策以及获取您个人信息的方法和措施，这些第三方的隐私权保护政策、获取个人信息的方法和措施将不会受到中保车服的控制。虽然中保车服将与可能接触到您的个人信息的中保车服的合作方及供应商第三方签署保密协议并尽合理的努力督促其履行保密义务，但中保车服无法保证第三方一定会按照中保车服的要求采取保密措施，中保车服亦不对第三方的行为及后果承担任何责任。
      </div>
      <div class="text-offset-2">3.信息更正或删除</div>
      <div class="text-offset-2">
        你随时可前往“个人中心"> "系统设置"> "修改密码"，来更正您的密码
      </div>
      <div class="text-offset-2">4.注销账号</div>
      <div class="text-offset-2">
        你随时可前往“个人中心"> "系统设置"> "注销账号" 点击注销按钮
        或者直接拨打<span
          style="color: #3399ff"
          @click="callPhone('4000026862')"
        >4000026862</span>联系中保客服进行注销
      </div>

      <div class="text-offset-2">
        5.中保车服将通过以下方式保障用户撤回同意的权利。当您撤回同意或授权后，可能导致中保车服无法为您继续提供撤回授权部分对应的服务。您撤回同意或授权，不影响撤回前基于您的同意开展的个人信息处理。
      </div>
      <div class="text-offset-2">
        你随时可前往“个人中心"> “APP权限设置”
        取消勾选，从而撤回您对隐私权限的同意
      </div>
      <div class="text-offset-2">6.关于中保车服</div>
      <div class="text-offset-2">
        中保车服科技服务股份有限公司是在中国保险行业协会的指导下，由太平洋保险、华安保险保险公司，联合蚂蚁金服、滴滴出行互联网领先企业，和深圳投控地方政府投资平台和社会相关企业共同出资建设的互联网保险服务平台。首期注册资金6亿元，注册地位于深圳市。
      </div>
      <div class="text-offset-2">7.如何联系中保车服</div>
      <div class="text-offset-2">
        如果您对本隐私政策有任何疑问、意见或建议，或您在使用时，就您的个人信息的收集、使用、共享、查询、删除、更正相关事宜有任何意见或建议，或您在使用产品或服务时遇到哪些问题，您都可以通过以下方式联系中保车服，中保车服将在15天内答复您的请求;
      </div>
      <div class="text-offset-2">
        客服联系电话：<span
          style="color: #3399ff"
          @click="callPhone('4000026862')"
        >4000026862</span>
      </div>

      <div class="text-offset-2">
        个人信息保护负责人联系方式：<span
          style="color: #3399ff"
          @click="callPhone(infoProtectionPhone)"
        >{{ infoProtectionPhone }}
        </span>
      </div>
      <div class="text-offset-2">
        公司联系地址：深圳市福田区华富街道莲花一村社区皇岗路5001号深业上城(南区)T2栋4409
      </div>

      <div class="first-wrap">七、中保车服如何处理未成年人的个人信息</div>
      <div class="text-offset-2">
        中保车服的产品和服务主要面向成人。如果没有父母或监护人的同意，未成年人不应创建自己的个人信息主体账户。
      </div>
      <div class="text-offset-2">
        对于经父母同意而收集未成年人个人信息的情况，中保车服只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。
      </div>
      <div class="text-offset-2">
        尽管当地法律和习俗对未成年人的定义不同，但中保车服将不满18周岁的任何人均视为未成年人。
      </div>
      <div class="text-offset-2">
        如果中保车服发现自己在未事先获得可证实的父母同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。
      </div>

      <div class="first-wrap">
        八、中保车服如何委托处理、共享、转让、公开披露您的个人信息
      </div>
      <div class="text-offset-2">
        （1）委托处理
        本业务功能中某些具体的模块或功能由外部供应商提供。例如中保车服会聘请服务提供商来协助中保车服提供客户支持。对中保车服委托处理个人信息的公司、组织和个人，中保车服会与其签署严格的保密协定，要求他们按照中保车服的要求、本个人信息保护政策以及其他任何相关的保密和安全措施来处理个人信息。
      </div>
      <div class="text-offset-2">
        （2）共享
        中保车服不会与本公司以外的任何公司、组织和个人分享您的个人信息，除非获得您的同意。
      </div>
      <div class="text-offset-2">（3）转让</div>
      <div class="text-offset-2">
        中保车服不会将您的个人信息转让给任何公司、组织和个人，但以下情形除外：
      </div>
      <div class="text-offset-2">
        a)
        在获取明确同意的情况下转让：获得您的明确同意后，中保车服会向其他方转让您的个人信息；
      </div>
      <div class="text-offset-2">
        b)
        在涉及合并、收购或破产清算时，如涉及到个人信息转让，中保车服会在要求新的持有您个人信息的公司、组织继续受此个人信息保护政策的约束，否则中保车服将要求该公司、组织重新向您征求授权同意。
      </div>
      <div class="text-offset-2">（4）公开披露</div>
      <div class="text-offset-2">
        中保车服仅会在以下情形下，公开披露您的个人信息：
      </div>
      <div class="text-offset-2">a) 获得您明确同意后；</div>
      <div class="text-offset-2">
        b)
        基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，中保车服可能会公开披露您的个人信息。
      </div>
      <div class="text-offset-2">（5）第三方SDK类服务商：</div>
      <div class="text-offset-2">
        a)
        获得您明确同意后，中保车服的产品中可能会包含第三方SDK或其他类似的应用程序，如您在中保车服平台上使用这类由第三方提供的服务时，您同意将由其直接收集和处理您的信息（如以嵌入代码、插件等形式）。
      </div>
      <div class="text-offset-2">
        前述服务商收集和处理信息等行为遵守其自身的隐私条款，而不适用于本政策。为了最大程度保障您的信息安全，中保车服建议您在使用任何第三方SDK类服务前先行查看其隐私条款。为保障您的合法权益，如您发现这等SDK或其他类似的应用程序存在风险时，建议您立即终止相关操作并及时与中保车服取得联系。
      </div>

      <div class="first-wrap">九、个人信息的存储和保护</div>
      <div class="text-offset-2">1.个人信息的存储</div>
      <div class="text-offset-2">1.1 存储地点</div>
      <div class="text-offset-2">
        本平台依照法律法规的规定，将在境内运营过程中收集和产生的您的个人信息，存储于中华人民共和国境内；本平台不会将您的个人信息传输至境外，如果需向境外传输，本平台将会遵循相关国家规定或者另行征求您的同意。
      </div>
      <div class="text-offset-2">1.2 存储期限</div>
      <div class="text-offset-2">
        a.
        期限保存：在您使用本平台服务期间即未注销帐号期间，本平台会持续保存您的个人信息；当您注销账号，本平台将按照法律、法规规定的最短期限保存您的个人信息；在最短保存期限内，本平台将不再对您的个人信息进行商业化使用；超出最短保存期限，本平台将会对您的个人信息进行匿名化处理。
      </div>
      <div class="text-offset-2">
        b.
        诉讼时效期间内保存：为配合人民检察院、公安机关、国家安全机关侦查犯罪行为之需要，当用户自主注销账户，本平台将在刑法规定的犯罪追诉时效期间内，加密隔离存档用户个人信息。
      </div>
      <div class="text-offset-2">
        c.
        永久保存：如用户使用本平台服务的过程中，存在严重违反法律法规、平台服务协议等情形，用户的违法、违约记录及相应的平台信用记录，将被永久保存。
      </div>
      <div class="text-offset-2">2. 个人信息的保护</div>
      <div class="text-offset-2">
        2.1
        本平台将在技术方面和管理方面努力采取合理的安全措施，来保护您的个人信息，防止您提供的个人信息被不当使用或在未经授权的情况下被访问、公开披露、使用、损坏、丢失或泄漏。
      </div>
      <div class="text-offset-2">
        a.
        技术方面：本平台会使用加密技术和数据隔离技术、匿名化处理、加密传输技术及相关合理可行必要的手段保护您的个人信息，并使用安全保护机制防止您的个人信息遭到恶意攻击或泄露。
      </div>
      <div class="text-offset-2">
        例如：本平台向您和乘客展示的对方个人信息用于身份核验时，所展示的个人信息以满足核验需求为限，本平台向您展示的乘客的信息包括乘客的手机号码最后四位、评价信息；订单匹配后，本平台为您和乘客提供虚拟号码电话沟通渠道；订单完成后，本平台为您保留用于纠纷处理的虚拟号码联系通道。
      </div>
      <div class="text-offset-2">
        b.
        管理方面：本平台会制定数据安全管理规范，明确对用户数据信息的保护标准和要求，建立专门的安全部门、安全管理制度、数据安全监控和审计制度、数据安全流程，设立完善的敏感数据访问权限申请及审批制度，定期开展面向公司核心人员或全体员工的信息安全教育及培训，以保障您的个人信息安全，同时本平台会采取严格的数据使用和访问制度，严格确保只有授权人员才可访问您的个人信息。
      </div>

      <div class="first-wrap">十、Cookie的使用</div>
      <div class="text-offset-2">
        您访问去本应用或使用本应用提供的服务时，中保车服可能会通过小型数据文件识别您的身份，这么做可以帮您省去重复输入注册时的信息的步骤，或者帮助判断您的账户安全状态。这些数据文件可能是Cookie,
        您的浏览器或关联应用程序提供的其他本地存储（以下简称Cookie）。请您理解，中保车服的某些服务只能通过使用
        Cookie 才可得到实现。如您的浏览器或浏览器附加服务允许，您可以修改对
        Cookie
        的接受程度或者拒绝本应用的Cookie。多数浏览器工具中的“帮助”部分会告诉您怎样防止您的浏览器接受新的
        Cookie，怎样让您的浏览器在您收到一条新Cookie
        时通知您或者怎样彻底关闭Cookie。此外，您可以通过改变浏览器附加程序的设置，或通过访问提供商的网页，来关闭或删除浏览器附加程序使用的类似数据。但这一举动在某些情况下可能会影响您安全访问本应用和使用本应用提供的服务。
      </div>

      <div class="first-wrap">十一、为您提供信息或服务</div>
      <div class="text-offset-2">
        <span class="importance">收集必要性: </span>订单推荐是该 app
        最基础、最核心的功能之一。为实现这一功能，中保车服可能会收集并使用下列信息:城市和您的注册信息;
      </div>
      <div class="text-offset-2">
        <span class="importance">收集目的：</span>获得您的明示同意后访问您的定位功能并获取您的地理位置信息，相关技术包括IP
        地址、<span class="importance">GPS</span> 以及能够提供相关信息的 Wi-Fi
        接入点、蓝牙和基站传感器技术。中保车服需要收集您的设备信息、位置信息、网络身份标识信息。中保车服会对用户的位置信息进行定位计算和费用计算，帮助您和其他用户获得<span
          class="importance"
        >更加精准的定位、导航和路线规划服务</span>。如果您同意开启定位功能并授权使用您的地理位置信息，中保车服会持续以5秒1次的频率收集您的位置信息，从而在您接收订单推荐服务及接单时，能更准确的向您提供基于地理位置的相关服务。中保车服在前台静默和后台运行时也会保持前述收集行为，以保证您能及时匹配订单。您可以通过系统授权关闭定位功能，停止对您的地理位置信息的收集。如果您拒绝提供该信息，中保车服将不能基于地理位置向您推送最匹配的信息，但不影响其他功能与服务的正常使用。请您了解，中保车服收集、使用的上述信息进行了去标识化处理，数据分析仅对应特定的、无法直接关联用户身份的编码，无法也绝不会与您的真实身份相关联。
      </div>
      <div class="text-offset-2">
        中保车服承诺在使用上述数据的过程中，不会侵害公民、法人和其他组织的合法权益；不会危害国家安全、荣誉和利益；并将恪守个人信息保护的各项原则，根据法律法规的相关要求，谨慎地使用您的数据。
      </div>

      <div class="first-wrap">十二、自启动和关联启动说明</div>
      <div class="text-offset-2">
        1、为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的信息，本应用须使用(自启动)能力，将存在一定频率通过系统发送广播唤醒本应用自启动或关联启动行为,是因实现功能及服务所必要的。
      </div>
      <div class="text-offset-2">
        2、当您打开第三方app时，在征得您的明确同意后，会跳转打开相关内容。在未征得您同意的情况下，则不会有自启动或关联启动。
      </div>

      <div class="first-wrap">十三、本政策如何更新</div>
      <div class="text-offset-2">
        1、隐私政策可能不定时更新，您应定期查看以了解中保车服保护所收集之个人信息的方案及程序，对于重大变更
        中保车服亦会通过弹窗方式通知您重新阅读中保车服更新后的隐私政策，并取得您的授权。
      </div>

      <div class="first-wrap">十四、第三方SDK</div>
      <div class="text-offset-2">
        1、为保APP相关功能的实现与应用安全稳定的运行，中保车服会接入由第三方提供的软件开发包SDK，实现相关目的，中保车服会对合作方获取信息的软件工具开发包(SDK)进行严格的安全监测以保护数据安全。中保车服接入的第三方SDK的用户个人信息使用情况请点击<span
          style="color: #3399ff"
          @click="gotoShardList"
        >《第三方信息共享清单》</span>或<span
          style="color: #3399ff"
          @click="gotoThirdSDK"
        >《第三方SDK目录》</span>查看。<span
          class="importance"
        >请注意，第三方SDK可能因为其版本升级、策略调整等原因导致数据处理类型存在一定变化，请以第一方SDK的隐私政策说明为准。</span>
      </div>
    </div>
    <div>
      <a
        :href="`tel:${phone}`"
        ref="telPhoneRef"
        style="display: none"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: 'Privacy',
  data() {
    return {
      appType: 'vas', // 默认大虾师傅的
      appTitle: {
        vas: '大虾师傅',
        aii: '好医探',
        zbcf: '中保车服务'
      },
      phone: ''
    };
  },
  created() {
    // if (this.$route.query.appType) {
    //   this.appType = this.$route.query.appType;
    // }
  },
  mounted() {
    if (this.$route.query.appType) {
      this.appType = this.$route.query.appType;
    }
  },
  computed: {
    appTypeTitle() {
      return this.appTitle[this.appType];
    },
    isAii() {
      return this.appType === 'aii';
    },
    infoProtectionPhone() {
      return this.appType === 'vas' ? '13632606530' : '14775863223';
    }
  },
  methods: {
    gotoShardList() {
      if (this.appType === 'aii') {
        this.$router.push('sharedListAii');
      } else if (this.appType === 'zbcf') {
        this.$router.push('sharedListZbcf');
      } else {
        this.$router.push('sharedList');
      }
    },
    gotoThirdSDK() {
      this.$router.push('ThirdSdk');
    },
    callPhone(phone) {
      this.phone = phone;
      this.$dialog
        .confirm({
          title: '提示',
          message: `你确定拨打：${phone} 电话吗？`
        })
        .then(() => {
          this.$refs.telPhoneRef.click();
        })
        .catch(() => {
          // on cancel
        });
    }
  }
};
</script>
<style lang="scss" scoped>
$indent: 20px;
.text-offset-2 {
  text-indent: $indent;
}

.privacy-wrap {
  min-height: 100vh;
  color: #383838;
  font-size: 16px;
  padding: 12px;
  padding-bottom: 24px;
  line-height: 24px;
  font-weight: 400;

  .title-wrap {
    font-size: 20px;
    font-weight: 700;
    width: 100%;
    text-align: center;
    margin-top: 24px;
  }

  .top-space {
    margin-top: 24px;
    margin-bottom: 32px;
  }

  .importance {
    font-weight: 700;
    color: #3399ff;
  }

  .normal {
    font-weight: 400;
    color: #383838;
  }

  .first-wrap {
    font-weight: 700;
    margin-top: 12px;
    text-indent: $indent;
  }
}
</style>
